import type { GameMeta } from '@gmp/game-sdk';

export const objectionMeta = {
  id: 'objection',
  name: 'Objection!',
  tagline: 'Absurd trials, one planted exhibit, and a jury that wants blood (or biscuits).',
  description:
    'Every case puts someone on trial for something ridiculous. The defendant files an alibi, the prosecutor an accusation, witnesses testify, and everyone enters an exhibit. One exhibit is secretly planted. The jury votes on the verdict and tries to spot the plant. Play over a coffee break or over a week.',
  minPlayers: 3,
  maxPlayers: 10,
  estimatedMinutes: [15, 30],
  usesMedia: false,
  modes: [{ id: 'trial', name: 'Trial', description: 'One case per pair of players, so everyone argues at least once.' }],
  theme: { primary: '#e0b04a', secondary: '#c4364a', background: '#1a1210', ink: '#fdf3e1' },
  readiness: 'beta',
  genre: 'Courtroom comedy and bluffing',
  controls: 'tap',
  category: 'async',
  asyncInfo: {
    turnSeconds: [30, 90],
    match: { quick: '15–30 min', daily: '3–10 days' },
    difficulty: 'easy',
    tags: ['funny', 'bluffing', 'social'],
  },
  instructions: [
    { icon: 'Gavel', title: 'Get your role', body: 'Each case has a defendant, a prosecutor, maybe witnesses, and a jury. Everyone argues at least once.' },
    { icon: 'FileText', title: 'File your case', body: 'Advocates and witnesses write a short statement and enter one exhibit from their hand. One of you has been told your exhibit is planted.' },
    { icon: 'Scale', title: 'The jury decides', body: 'Jurors vote guilty or not guilty and name the exhibit they think was planted.' },
    { icon: 'Trophy', title: 'Verdict', body: 'Win your case, spot the plant, vote with the jury, or fool them all. Play at your own pace: the case moves on when everyone is in or the time runs out.' },
  ],
} satisfies GameMeta;
